import React, { useState } from 'react'
import Context from './CommonContext'

function CommonProvider(props) {


    // const [BaseURL, setBaseURL] = useState("https://www.moneysukh.com/api/markets/");

    // const [BaseURL, setBaseURL] = useState("/api/markets/");

    // const [BaseURL, setBaseURL] = useState("http://cmweb:695/api/");
    const [BaseURL, setBaseURL] = useState("https://moneysukhapi.cmots.com/api/");
    const [CRMBaseURL, setCRMBaseURL] = useState("https://moneysukh.myfreshworks.com/crm/sales/api/");
    const [BaseLiveURL, setBaseLiveURL] = useState("https://www.moneysukh.com/");
    const [clientId, setclientId] = useState("458155414567-p503q8buhbgku64op2pmnm3r34ppqj64.apps.googleusercontent.com");
    return (
        <Context.Provider value={{ ...props, BaseURL, setBaseURL: setBaseURL, clientId, setclientId: setclientId, CRMBaseURL, setCRMBaseURL: setCRMBaseURL, BaseLiveURL, setBaseLiveURL: setBaseLiveURL }}>{props.children}</Context.Provider>
    )
}

export default CommonProvider